import Box, { BoxProps } from '@mui/material/Box';
import { PropsWithChildren } from 'react';
import { Link } from 'react-router';
import FlexBox, { FlexBoxProps } from '../layout/FlexBox';
import ImageThumbnail from './ImageThumbnail';

type ThumbnailLayoutProps = FlexBoxProps & {
  imageUrl?: string;
  imageAlt?: string;
  imageProps?: BoxProps['sx'] & {
    to?: string;
    objectFit?: 'cover' | 'contain';
  };
  fallback?: React.ReactNode;
};

const ThumbnailLayout: React.FC<PropsWithChildren<ThumbnailLayoutProps>> = ({
  imageUrl,
  imageAlt,
  imageProps,
  fallback,
  children,
  ...props
}) => (
  <FlexBox gap={3} alignItems={'center'} {...props}>
    <Box
      component={imageProps?.to ? Link : 'div'}
      to={imageProps?.to}
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        textDecoration: 'none',
        ...(imageProps?.to && { cursor: 'pointer' }),
      }}
    >
      <ImageThumbnail
        imageUrl={imageUrl}
        alt={imageAlt}
        objectFit={imageProps?.objectFit}
        fallback={fallback}
        sx={{
          width: '5rem',
          height: '5rem',
          minWidth: '5rem',
          ...imageProps,
        }}
      />
    </Box>
    {children}
  </FlexBox>
);

export default ThumbnailLayout;
